// Copyright (c) StrangeBee 2023

import { Form } from 'antd';
import React, { ReactElement } from 'react';
import { CounterWidgetType, WidgetOutput } from 'thehive-sdk';
import { useDashboard } from '@Hooks/useDashboard';
import WidgetDrawer from '@Organisms/Dashboard/WidgetManage/WidgetDrawer';
import { CounterForm, CounterValues } from '@Organisms/Dashboard/WidgetManage/Counter/CounterForm';
import { getNewCounterWidget } from './NewCounterDrawer';

interface CounterDrawerProps {
    data: WidgetOutput & { options: CounterWidgetType };
}

const CounterDrawer = ({ data }: CounterDrawerProps): ReactElement => {
    const [form] = Form.useForm();
    const { editWidget } = useDashboard();

    const onFinish = (counter: CounterValues): void => {
        const widgetId = data.id;
        const widgetCounter: WidgetOutput & { options: CounterWidgetType } = {
            ...getNewCounterWidget(counter),
            id: widgetId,
        };

        editWidget(widgetCounter, widgetId);
        form.resetFields();
    };

    return (
        <WidgetDrawer form={form} widgetType="counter">
            {(toggleDrawer, { setFieldsTouched }) => (
                <CounterForm
                    onCancel={() => {
                        form.resetFields();
                        setFieldsTouched(false);
                        toggleDrawer();
                    }}
                    onChange={() => {
                        setFieldsTouched(true);
                    }}
                    form={form}
                    onFinish={(values) => {
                        onFinish(values);
                        toggleDrawer();
                    }}
                    defaultValues={data}
                />
            )}
        </WidgetDrawer>
    );
};

export default CounterDrawer;
